import { render } from "./EntradasProductos.vue?vue&type=template&id=9abf7996&scoped=true"
import script from "./EntradasProductos.vue?vue&type=script&lang=js"
export * from "./EntradasProductos.vue?vue&type=script&lang=js"

import "./EntradasProductos.vue?vue&type=style&index=0&id=9abf7996&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9abf7996"]])

export default __exports__